const wrapperCls = "_rsw1okydpy";
const tableCls = "_rst19tgb72";
const defaultStylingTableCls = "_rsd1vykvg9";

export { defaultStylingTableCls, tableCls, wrapperCls };
import "./table.style.linaria.module.css";
//# sourceMappingURL=table.style.js.map
